import {getLocaleByHostname, Locale} from '@aboutyou/config';
import {getCurrentRouteFromUrl, PageTypes} from '@aboutyou/router';
import type {Request} from 'express';
import {isAppCheckoutRequest} from './isAppCheckout';
import {
  isAppLinksSubdomainRequest as getIsAppLinksSubdomainRequest,
  isAppCheckoutSubdomainRequest,
} from './isAppCheckoutSubdomainRequest';
// eslint-disable-next-line monorepo/no-internal-import
import {getTransactionName} from '@aboutyou/logic-components/src/client-services/DatadogLogsRouteTracker/getTransactionName';

export const getCurrentPageInfo = (
  req: Request,
): {
  hostname: string;
  locale?: Locale;
  pageType?: PageTypes;
  viewName: string;
  isAppCheckout: boolean;
  isAppLinksSubdomainRequest: boolean;
} => {
  const isCheckoutSubdomainRequest = isAppCheckoutSubdomainRequest(req);
  const isAppCheckout = isAppCheckoutRequest(req);
  const isAppLinksSubdomainRequest = getIsAppLinksSubdomainRequest(req);

  const hostname = isCheckoutSubdomainRequest
    ? (req.query.originHostname as string)
    : req.hostname;

  const locale = getLocaleByHostname(hostname);
  const pageType = locale ? getCurrentRouteFromUrl(locale, req.url) : undefined;

  const transactionName = getTransactionName(req.url, pageType);

  return {
    hostname,
    locale,
    pageType,
    viewName: transactionName,
    isAppCheckout,
    isAppLinksSubdomainRequest,
  };
};
